import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import "@/assets/css/iconfont/iconfont.css"; 
import "@/assets/css/style.css"; 
import 'element-ui/lib/theme-chalk/index.css';
import Swiper from 'swiper';
import "swiper/dist/css/swiper.min.css";
import '@/assets/css/init.css';
import '@/assets/css/theme.css';
import '@/assets/css/element-theme.css';
import { initTheme } from './utils/theme';
initTheme();
import axios from './utils/axios'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueAxios, axios)


import table_table from '@/components/table_table'
Vue.component('table_table',table_table);

import pagination from '@/components/pagination'
Vue.component('pagination',pagination);

import upload from '@/components/upload';
Vue.component('upload',upload);

import uploads from '@/components/uploads';
Vue.component('uploads',uploads);

import upload_import from '@/components/upload_import';
Vue.component('upload_import',upload_import);


import {removeByIndex,getTime,router_url,hasBtn,transListDataToTreeData,convertToTreeData,array_object} from './utils/index'
import { getErrorMessage, showError } from './utils/error-message'

Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.transListDataToTreeData = transListDataToTreeData
Vue.prototype.convertToTreeData = convertToTreeData
Vue.prototype.array_object = array_object
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.$getErrorMessage = getErrorMessage
Vue.prototype.$showError = showError
import { post,get,export_blob,export_blob_post } from './utils/request.js'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$export_blob = export_blob
Vue.prototype.$export_blob_post = export_blob_post

import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
  	vuescroll:{wheelScrollDuration:200 },
		bar: {background: "var(--scrollbar, #c1c1c1)", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
  name: 'vueScroll'
});

import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js